import { z } from 'zod'
import { IsoDateTime, PageInfo } from './common'

// Workspace tables: the platform's own business records, one Postgres schema per workspace (P2).

export const FieldType = z.enum([
  'string',
  'number',
  'boolean',
  'date',
  'datetime',
  'json',
  'mobile',
  'pan',
  'email',
])
export type FieldType = z.infer<typeof FieldType>

export const TableField = z.object({
  name: z.string().regex(/^[a-z][a-z0-9_]*$/),
  type: FieldType,
  required: z.boolean().default(false),
  pii: z.boolean().default(false).describe('masked in the UI and in run records'),
  description: z.string().optional(),
})
export type TableField = z.infer<typeof TableField>

export const TableDefinition = z.object({
  id: z.string(),
  workspaceId: z.string(),
  name: z.string().regex(/^[a-z][a-z0-9_]*$/),
  schemaName: z.string(),
  description: z.string().default(''),
  fields: z.array(TableField).min(1),
  uniqueKeys: z.array(z.array(z.string())).default([]),
  retentionDays: z.number().int().min(1).nullable().describe('null = keep forever'),
  rowCount: z.number().int().min(0).default(0),
  createdAt: IsoDateTime,
  updatedAt: IsoDateTime,
})
export type TableDefinition = z.infer<typeof TableDefinition>

export const TableDefinitionInput = TableDefinition.omit({
  id: true,
  workspaceId: true,
  schemaName: true,
  rowCount: true,
  createdAt: true,
  updatedAt: true,
})
export type TableDefinitionInput = z.infer<typeof TableDefinitionInput>

export const TableRow = z.object({
  id: z.string(),
  tableId: z.string(),
  data: z.record(z.string(), z.unknown()),
  createdAt: IsoDateTime,
  updatedAt: IsoDateTime,
  createdByRunId: z.string().nullable().default(null),
})
export type TableRow = z.infer<typeof TableRow>

export const TableRowsPage = z.object({
  rows: z.array(TableRow),
  page: PageInfo,
})
export type TableRowsPage = z.infer<typeof TableRowsPage>
